<script setup>
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { useWidgetStore } from '@/stores/WidgetStore';

  const widgetStore = useWidgetStore();

  const props = defineProps({
    // A WIDGET_DEFINITIONS id from WidgetStore ('liveWind', 'windMap', …)
    widgetId: {
      type: String,
      required: true
    },
    // true: the editor's live preview, which can be panned, zoomed and focused
    interactive: {
      type: Boolean,
      default: false
    }
  });

  const { t } = useI18n();

  const embed = computed(() => widgetStore.embeds[props.widgetId]);
  const title = computed(() => t(widgetStore.getDefinition(props.widgetId).titleKey));
</script>

<template>
  <!-- The widget's live iframe; unless interactive it's a preview only, not interacted
       with or focused -->
  <iframe
    v-if="embed"
    :src="embed.src"
    :width="embed.width"
    :height="embed.height"
    :title="title"
    class="jwx-widget-preview__iframe"
    :data-interactive="props.interactive || null"
    :tabindex="props.interactive ? null : -1"
    :loading="props.interactive ? 'eager' : 'lazy'"
    frameborder="0"
    scrolling="no"
  ></iframe>
</template>
